import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=45c44af6&scoped=true"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"
import style0 from "./SliderComponent.vue?vue&type=style&index=0&id=45c44af6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c44af6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c44af6')) {
      api.createRecord('45c44af6', component.options)
    } else {
      api.reload('45c44af6', component.options)
    }
    module.hot.accept("./SliderComponent.vue?vue&type=template&id=45c44af6&scoped=true", function () {
      api.rerender('45c44af6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/component/SliderComponent.vue"
export default component.exports